import { PERMANENT_CONTAINER_TYPES } from 'src/utils/constants';

/**
 * An empty disposable container can be converted into a permanent container. The conversion
 * happens in place, so the QR code already printed on the container keeps working.
 *
 * @param {{ disposable?: boolean, type?: string, current_batch?: string, quantity?: number }} container
 * @returns {boolean}
 */
export const canConvertToPermanentContainer = container =>
  Boolean(
    container?.disposable &&
    container.type === PERMANENT_CONTAINER_TYPES.DISPOSABLE &&
    !container.current_batch &&
    !container.quantity
  );

/**
 * A material batch returns one `materials` entry per material lot, so the same material
 * shows up several times when a batch is merged from (or containerized across) multiple
 * lots of that material.
 *
 * Deduplicates on `uri`, so genuinely different materials are never collapsed together,
 * and keeps the first occurrence to preserve both the original order and the identity of
 * `materials[0]`. Falls back to `name` for entries without a `uri`.
 *
 * @param {Array<{ uri?: string, name?: string }>} materials `batch.materials`
 * @returns {Array<{ uri?: string, name?: string }>}
 */
export const dedupeBatchMaterials = materials => {
  const materialsByKey = new Map();

  for (const material of materials ?? []) {
    const key = material?.uri ?? material?.name;

    if (key && !materialsByKey.has(key)) {
      materialsByKey.set(key, material);
    }
  }

  return [...materialsByKey.values()];
};
